export const defaultState = () => {
    return {
        bundle: []
    }
}

const state = defaultState()
export default state
